// src/utils/tenant.js
export function resolveTenantHint(explicitTenant) {
  // 1) explicit (from form)
  if (explicitTenant && explicitTenant.trim()) return explicitTenant.trim();

  // 2) ?tenant=acme (support deep links)
  const params = new URLSearchParams(window.location.search);
  const qTenant = params.get('tenant');
  if (qTenant && qTenant.trim()) return qTenant.trim();

  // 3) previously chosen (remembered)
  const saved = localStorage.getItem('tenantSlug');
  if (saved && saved.trim()) return saved.trim();

  // 4) optional default via env
  const def = process.env.REACT_APP_DEFAULT_TENANT;
  if (def && def.trim()) return def.trim();

  // No subdomain inference on single URL
  return null;
}

export function rememberTenant(tenant) {
  if (tenant && tenant.trim()) {
    localStorage.setItem('tenantSlug', tenant.trim());
  }
}

export function clearRememberedTenant() {
  localStorage.removeItem('tenantSlug');
}
